import { useBoolean } from 'ahooks'
import { Typography } from 'antd'

import { DraggableModal } from '@eastcoal/common/components/DraggableModal'
import { BasicProps } from '@eastcoal/common/types/component'

import { RichEditor } from '@eastcoal/editor/index'

import { USER_AGREEMENT_TEXT } from './terms'

export const UserAgreement = ({ className, style }: BasicProps) => {
  const [open, openActions] = useBoolean(false)

  return (
    <>
      <Typography.Link
        className={className}
        style={style}
        onClick={openActions.setTrue}
      >
        《用户服务协议和隐私保密协议》
      </Typography.Link>
      <DraggableModal
        okText='我已知晓'
        open={open}
        title='用户服务协议和隐私保密协议'
        width='80%'
        cancelButtonProps={{
          hidden: true
        }}
        styles={{
          body: {
            height: 540,
            overflow: 'auto'
          }
        }}
        onOpenChange={openActions.set}
      >
        <RichEditor readPretty value={USER_AGREEMENT_TEXT} />
      </DraggableModal>
    </>
  )
}
